import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { ApiService } from "../../../services/api.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '@components/button/button.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-claim',
  templateUrl: './new-claim.component.html',
  styleUrl: './new-claim.component.scss',
  standalone: true,
  imports: [TranslateModule, ButtonComponent, CommonModule],
})
export class NewClaimComponent {
    shouldShowContactModal: boolean = false;
    minDocsUrl: string | null = null;

    constructor(
        private router: Router,
        private api: ApiService,
        private translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            if (userInfo?.country) {
                this.fetchMinDocsUrl(userInfo.country.toLowerCase());
            }
        });

        this.translateService.onLangChange.subscribe(() => {
            const stored = localStorage.getItem('weUserInfo');
            if (stored) {
                const { country } = JSON.parse(stored);
                this.fetchMinDocsUrl(country.toLowerCase());
            }
        });
    }

    private fetchMinDocsUrl(country: string): void {
        const language = this.translateService.currentLang || undefined;
        this.api.getClaimsMinDoc(country, language).subscribe({
            next: (doc: any) => (this.minDocsUrl = doc?.url ?? null),
            error: () => (this.minDocsUrl = null),
        });
    }

    goToCreateClaim() {
        this.router.navigate(['create-claim']);
    }

}
